export default __webpack_public_path__ + "static/media/portfolio-57.ab0b07aa.jpg";